const PageWrapper = ({ children }) => {
  return <div className="pb-6 max-w-screen-xl mx-auto">
    {children}
  </div>
}

export default PageWrapper;